const MembersSection = () => {
  return (
    <section className="py-20" data-cy="members-section">
      <div className="text-center text-6xl font-bold">
        3 million members and counting
      </div>
    </section>
  );
};

export default MembersSection;
